import React from 'react';
import { Button, Checkbox, Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import { Sider as SiderUI } from 'components/ui/index';

const { FieldTypes } = Enums;
const { Lookup, PickList } = FieldTypes;
const CheckboxGroup = Checkbox.Group;

const defaultProps = {};

const propTypes = {
  rightSiderValue: PropTypes.object.isRequired,
  hadleSiderClose: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
};

/**
 * @This is for Workflow filter side bar list
 */

class Sider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { rightSiderValue } = this.props;
    if (prevProps.rightSiderValue.value !== rightSiderValue.value) {
      this.setSelectedValue(rightSiderValue.value);
    }
  }

  componentWillUnmount() {
    const { hadleSiderClose } = this.props;
    hadleSiderClose();
  }

  onAddClick = () => {
    const { rightSiderValue, handleValueChange } = this.props;
    const { checkedValues } = this.state;
    const valueName = checkedValues.map(checkedValue => {
      const selectedValue = rightSiderValue.options.find(siderValue => siderValue.value === checkedValue);
      return selectedValue.label;
    });
    const formatValue = this.valueToString(valueName);
    handleValueChange(formatValue, rightSiderValue.displayNum);
  }

  onDoneClick = () => {
    const { hadleSiderClose } = this.props;
    hadleSiderClose();
    this.setState({ checkedValues: [] });
  }


setSelectedValue = value => {
  const { rightSiderValue } = this.props;
  const valueId = this.mapSelectedValue(rightSiderValue.options, value);
  this.setState({ checkedValues: valueId });
}

// split the input string based on the longest match in option list
mapSelectedValue = (arr, str) => {
  let inputStringWithoutWhitespacesAndLower = str.replace(/\s/g, '').toLowerCase();
  const optionList = arr;
  const sortedOptionList = [...optionList].sort((a, b) => b.label.length - a.label.length);
  const output = [];
  // stop the loop if the substring of inputString is ""
  while (inputStringWithoutWhitespacesAndLower.length > 0) {
    let hasCountry = false;
    for (let i = 0; i < sortedOptionList.length; i++) {
      const optionValWithoutWhitespacesAndLower = sortedOptionList[i].label.replace(/\s/g, '').toLowerCase();
      if (inputStringWithoutWhitespacesAndLower.startsWith(optionValWithoutWhitespacesAndLower)) {
        output.push(sortedOptionList[i].value);
        hasCountry = true;
        inputStringWithoutWhitespacesAndLower = inputStringWithoutWhitespacesAndLower.substring(optionValWithoutWhitespacesAndLower.length + 1, inputStringWithoutWhitespacesAndLower.length);
        break;
      }
    }
    // if there is NO startswith match value in the option list
    if (!hasCountry) {
      const commaIndex = inputStringWithoutWhitespacesAndLower.indexOf(',');
      // if it's NOT the last substring in the inputString
      if (commaIndex > -1) {
        inputStringWithoutWhitespacesAndLower = inputStringWithoutWhitespacesAndLower.substring(commaIndex + 1, inputStringWithoutWhitespacesAndLower.length);
      } else {
        inputStringWithoutWhitespacesAndLower = '';
      }
    }
  }
  return output;
}


  valueToString = value => value.join();

  handleOptionChange = checkedValue => {
    this.setState({ checkedValues: checkedValue });
  }

  render() {
    const { width, rightSiderValue } = this.props;
    const { checkedValues } = this.state;
    const i18n = 'global.ui';

    return (
      <SiderUI position="right" style={{ width }}>
        <div className="pt-xlg pr-lg pb-xlg pl-lg">
          {rightSiderValue && rightSiderValue.displayNum ? (
            <div className="mb-md">
              Options for display number {rightSiderValue.displayNum}
            </div>
          ) : null}
          <CheckboxGroup
            className="block"
            options={rightSiderValue.options}
            value={checkedValues}
            onChange={this.handleOptionChange}
          />
          <div className="mt-lg">
            <Button
              className="mr-sm"
              onClick={this.onAddClick}
              size="small"
            >
              <Icon className="font-sm" type="plus" />
              <FormattedMessage id={`${i18n}.button.add`} />
            </Button>
            <Button onClick={this.onDoneClick} size="small">
              <Icon className="font-sm" type="check" />
              <FormattedMessage id={`${i18n}.button.done`} />
            </Button>
          </div>
        </div>
      </SiderUI>
    );
  }
}

const mapStateToProps = ({ ui }) => ({
  collapsed: ui.rightSider.collapsed,
  width: ui.siders.right,
});
const mapDispatchToProps = {};

Sider.propTypes = propTypes;
Sider.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(Sider);




// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/components/Sider/index.jsx